export default __webpack_public_path__ + "static/media/achadissimosoficial.39a5da95.jpg";